import React from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { RemoveCircleIcon } from "components"
import { H5, H6, Interactive, P, InfoIcon, Space } from "AtomicComponents"
import { Disclaimer, Image } from "AtomicContainers"
import COLOR_PALETTE from "constants/color-palette"

let RemoveVehicleButton = ({ children, onClick, disabled }) => (
  <div
    onClick={!disabled ? onClick : () => {}}
    style={[
      removeButtonStyles.wrapper,
      disabled ? { opacity: 0.5 } : removeButtonStyles.interactive
    ]}>
    <div style={removeButtonStyles.icon}>
      <RemoveCircleIcon style={{ display: "block", height: "20px", width: "20px" }} />
    </div>
    <Interactive>{children}</Interactive>
  </div>
)

RemoveVehicleButton.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.string,
  onClick: PropTypes.func
}

RemoveVehicleButton = Radium(RemoveVehicleButton)


// Taken from src/containers/outlet-store/stock-tile.jsx:68
const conditionalTitle = (nameplate, bodyStyle, grade, driveTransmission) => {
  if (
    (nameplate && nameplate.toLowerCase().includes("cx"))
  ) {
    return [grade, driveTransmission].filter(Boolean).join(" ")
  }
  if (bodyStyle && bodyStyle.toLowerCase().includes("rf")) {
    return grade
  }
  return [bodyStyle, grade].filter(Boolean).join(" ")
}

const removeButtonStyles = {
  interactive: {
    transition: "color 0.25s",
    cursor: "pointer",
    ":hover": {
      color: COLOR_PALETTE.GRAY_DARK
    }
  },
  wrapper: {
    color: COLOR_PALETTE.GRAY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "87%"
  },
  icon: {
    paddingRight: "0.5em"
  }
}

const MyMazdaVehicleTile = ({
  nameplate,
  grade,
  bodyStyle,
  imageUrl,
  status,
  driveTransmission,
  registrationNumber,
  nextServiceDateStr,
  nextServiceDisclaimer,
  removeOnClick,
  disabled,
  cta
}) => (
  <div style={styles.tile}>
    <div style={styles.base}>
      <div style={styles.coverImg}>
        <div
          style={{
            padding: "1.5em 1.5em 0.5em",
            textAlign: "center",
            display: "flex",
            height: "100%",
            flexDirection: "column",
            justifyContent: "space-between",
            boxSizing: "border-box"
          }}>
          <div style={{ width: "100%", position: "relative" }}>
            <H5 withDetails>{nameplate}</H5>
            <P withoutMargin>
              <Interactive>
                {[
                  conditionalTitle(nameplate, bodyStyle, grade, driveTransmission),
                  registrationNumber
                ].filter(Boolean).join(" | ")}
              </Interactive>
            </P>
          </div>
          <Image src={imageUrl + "?width=440"} />
        </div>
      </div>
      <div style={styles.details}>
        <div style={{ textAlign: "center" }}>
          <H6 withDetails>
            {
              status ? (
                <span>Vehicle status</span>
              ) : (
                <span>
                  Next Service
                  {
                    nextServiceDisclaimer &&
                    <Disclaimer Icon={InfoIcon}>
                      {nextServiceDisclaimer}
                    </Disclaimer>
                  }
                </span>
              )
            }
          </H6>
          <P withoutMargin>{status || nextServiceDateStr}</P>
          <Space />
          {cta}
          <Space />
          <div style={styles.hr} />
          <RemoveVehicleButton disabled={disabled} onClick={removeOnClick}>Remove Vehicle</RemoveVehicleButton>
        </div>
      </div>
    </div>
  </div>
)

MyMazdaVehicleTile.propTypes = {
  nameplate: PropTypes.string,
  grade: PropTypes.string,
  bodyStyle: PropTypes.string,
  imageUrl: PropTypes.string,
  disabled: PropTypes.bool,
  status: PropTypes.string,
  registrationNumber: PropTypes.string,
  nextServiceDateStr: PropTypes.string,
  nextServiceDisclaimer: PropTypes.string,
  removeOnClick: PropTypes.func,
  cta: PropTypes.node
}

const styles = {
  base: {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
    boxSizing: "border-box",
    border: `1px solid ${COLOR_PALETTE.GRAY}`,
    minHeight: "230px",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    textDecoration: "none",
    color: "#101010",
    transition: "opacity 0.5s"
  },
  nameplateDetails: {
    margin: 0,
    fontWeight: 400,
    fontSize: "87%",
    lineHeight: "18px",
    color: COLOR_PALETTE.GRAY_DARK
  },
  coverImg: {
    left: "0px",
    top: "0px",
    bottom: "0px",
    overflow: "hidden",
    boxSizing: "border-box",
    position: "relative",
    width: "100%",
    height: "230px",
    backgroundColor: "#f5f5f5"
  },
  details: {
    padding: "1.5em 1.5em 1em",
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginLeft: "0px",
    width: "100%"
  },
  hr: {
    width: "100%",
    borderBottom: "1px solid rgb(229, 229, 229)",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: "1em",
    paddingBottom: "0.5em"
  },
  tile: {
    display: "flex",
    maxWidth: "270px",
    width: "270px",
    flex: "1 0 auto"
  }
}

export default Radium(MyMazdaVehicleTile)



// WEBPACK FOOTER //
// ./src/components/mymazda/vehicle-list/vehicle-tile.jsx